import React from "react";
import { useMeetingAppContext } from "../../MeetingAppContextDef";
import { VerticalTemplates } from "../../services/Templates";
import { useSiteContext } from "../../context/SiteContext";
import { usePubSub } from "@videosdk.live/react-sdk";

const PrompterSection = ({
  height,
  sideBarContainerWidth,
  paddedHeight,
  mobilePanelHeight,
  panelPadding,
  isMobile,
  isTab,
}) => {
  const {
    activeElement,
    setActiveElement,
    setShowElementSection,
    meetingRole,
    prompterElement,
    setPrompterElement,
  } = useSiteContext();
  const { sideBarMode } = useMeetingAppContext();
  const { publish: publishCloseElementSection } = usePubSub(
    "CLOSE_ELEMENT_SECTION"
  );

  const topBarHeight = 64;
  const bottomBarHeight = 80;

  const settings = prompterElement?.settings
    ? typeof prompterElement.settings === "string"
      ? JSON.parse(prompterElement.settings)
      : prompterElement.settings
    : {};

  // Get theme from settings, default to "light"
  const theme = settings.theme || "light";

  const PrompterComponent = VerticalTemplates["prompter"]?.preview;

  const getStyle = () => {
    // Match sidebar positioning and dimensions exactly - use same height calculations
    if (isMobile || isTab) {
      // On mobile/tablet, match the sidebar's full-screen modal behavior
      return {
        width: "100%",
        height:
          mobilePanelHeight ||
          `calc(100vh - ${topBarHeight}px - ${bottomBarHeight}px)`,
        top: `${topBarHeight}px`,
        bottom: `${bottomBarHeight}px`,
        left: 0,
        right: 0,
      };
    } else {
      // On desktop, match sidebar width and position on the right
      // Use the paddedHeight passed from sidebar (same calculation)
      return {
        width: sideBarContainerWidth,
        height: paddedHeight || height,
        paddingTop: panelPadding,
        paddingLeft: panelPadding,
        paddingRight: panelPadding,
        paddingBottom: panelPadding,
        top: 0,
        right: 0,
      };
    }
  };

  return (
    <div
      className={`fixed z-10 transition-all duration-500 ease-in-out flex items-center justify-center`}
      style={getStyle()}
    >
      {PrompterComponent && prompterElement && (
        <div
          style={{
            width: "100%",
            height: "100%",
            borderRadius: isMobile || isTab ? 0 : 10,
            overflow: "hidden",
            backgroundColor: "#1f2937", // Match sidebar bg-gray-800
          }}
        >
          <PrompterComponent
            {...settings}
            theme={theme}
            inmeeting={true}
            position="center"
            onClose={() => {
              setPrompterElement(null);
              if (meetingRole === "moderator") {
                publishCloseElementSection(
                  JSON.stringify({
                    set: true,
                  })
                );
              }
            }}
          />
        </div>
      )}
    </div>
  );
};

export default PrompterSection;
